module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/E-novels/e-novel-season-add/e-novel-season-add.component.css
// module id = ./src/app/E-novels/e-novel-season-add/e-novel-season-add.component.css
// module chunks = main